import React from 'react';
import { useTranslation } from 'react-i18next';

import Link from 'components/ui/Link';
import { useSetLoginTitle } from './LoginContainer';
import StyledForm from './Form';

export default function RecoveryEmailSent({ className }) {
  const { t } = useTranslation('login');
  useSetLoginTitle(t('title.email_sent'));

  return (
    <StyledForm as="div" className={className}>
      <p>{t('message.email_sent')}</p>
      <p>{t('message.email_sent_hint')}</p>
      <Link to="/login">{t('title.login')}</Link>
    </StyledForm>
  );
}
